import {inject, Injectable} from '@angular/core';
import {APIService} from './api.service';
import {Observable} from 'rxjs';
import {IUpdateGoldRushAutoplayStatus} from "../interfaces/IUpdateGoldRushAutoplayStatus";
import {IUpdateAutoplayGroupStatus} from "../interfaces/IUpdateAutoplayGroupStatus";

@Injectable({
  providedIn: 'root'
})
export class AutoplayService {

  private apiService = inject(APIService)

  updateGoldRushAutoplayStatus(updateAutoPlaysRequestP: IUpdateGoldRushAutoplayStatus): Observable<any> {
    return this.apiService.MakePutRequest('player-number/admin-update-gold-rush-autoplay-status', updateAutoPlaysRequestP);
  }

  updateAutoplayGroupStatus(updateAutoplayGroupRequestP: IUpdateAutoplayGroupStatus): Observable<any> {
    return this.apiService.MakePutRequest('autoplay-group/update-status', updateAutoplayGroupRequestP);
  }
}
